// extracted by mini-css-extract-plugin
module.exports = {"page":"Order_style_page__18Py_"};